export default __webpack_public_path__ + "71da9a830e7ec48e7c8ac0ccaa9c5585.png";